import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

// Canonical always points at the non-www origin, regardless of which host
// (slinkflow.com or www.slinkflow.com) actually served the request. The
// www -> non-www 301 in public/_redirects should mean www never gets
// crawled directly, but the canonical tag is a second, independent signal
// that reinforces the same thing.
const CANONICAL_ORIGIN = 'https://slinkflow.com';

export default function SEO({ title, description, noindex = false }) {
  const { pathname } = useLocation();
  const canonicalPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/';
  const canonicalUrl = `${CANONICAL_ORIGIN}${canonicalPath === '/' ? '' : canonicalPath}`;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex,follow" />}
    </Helmet>
  );
}
